module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "container block-primary"
  }, [_c('h1', {
    staticClass: "header-title"
  }, [_vm._v("Credits")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Cart page: we use icon from by "), _c('a', {
    attrs: {
      "href": "https://www.flaticon.com/packs/logistics-delivery"
    }
  }, [_vm._v("Freepik")]), _vm._v(" from www.flaticon.com ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd00b6ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Credits.vue
// module id = 1226
// module chunks = 0